/// <summary>
/// This object provides js functions for multiple archives <br/>
/// <br/>
/// Author: MKU<br />
/// Date: 01.09.2024<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 01.09.2024                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>

const ButtonTextStyle = {
    height: "32px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    whiteSpace: "pre-line",
    marginRight: "0px",
};

const ButtonFlexBox = {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
};

const OverViewBtnStyle = {
    width: "40px",
    marginRight: "5px",
    fontSize: "17px",
};

jQuery.widget("bluaul.MultipleArchives", jQuery.common.vcBaseV4, {
    vcV: new vcVisual(),
    vcC: new vcCommon(),

    myStatus: {
        resources: null, // holds all data resources for data conversion
        currArchiveId: 0, // holds the arch id of the currently open archive
        uArchId: 0, // holds the unique arch id (incremental ascending ID)
        currDate: [], // selected date of the currently loaded archive
        newDate: [], // new date which is selected in the archive directly
        overview: null, // holds the overview div of the datacenter
        archives: [], // holds all open archives (entire object with div etc), which are opened via the DataCenter view
        menuButtons: [], // holds all archive menu buttons (entire object with div etc), which are part of the top menu to switch between different archives
        btnOverview: null, // holds the overview button in the top menu
        status: null, // holds old status
        loading: false,
        currentView: "overview", // "overview" | "archive"
        startParameter: null
    },

    defaultStatus: { },

    _create: function () {
        this._createVisual(364);
        this._super();        
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".multiple-archives");
            me._buildHtml();
            me._initOverview();
            me._getDateResources();
            return true;
        } catch (e) { me.writeError('_initHTML', e); return false; }
    },

    _initEvents: function () {
        var me = this;
        try {
            $(document).on("openSelectedArchiveEvent", function (event, obj, loggerName) {
                me.myStatus.startParameter = null;
                me.myStatus.startParameter = obj.StartParameter;
                console.log("me.myStatus.startParameter", me.myStatus.startParameter);

                if (me.myStatus.archives.length < 5) me._openSelectedArchive(obj, loggerName);
                else alert(me.specific.resources.tooManyOpenProjects);
            }); 

            me._addClickEventHandler(me.myStatus.btnOverview, function () {               
                var currArchive = me._getArchiveById(me.myStatus.currArchiveId);                
                if (currArchive) {
                    me.fnd('#btnLoad-' + me.myStatus.currArchiveId).removeClass('button-toggle-active');

                    // get the status of the currently open archive
                    var archWidget = me.myStatus.archive.find(".vc-menu");                  
                    archWidget.trigger('getStatusOfCurrArchive', { widgetId: archWidget.attr('id'), archiveId: me.myStatus.currArchiveId });                               
                }

                me.myStatus.currentView = "overview";
                me.myStatus.archive.hide();
                me.myStatus.loadScreen.hide();
                me._showOverview(); // open overview
            });    

            $(document).on('sendStatusOfCurrArchive', function (event, data) {
                me._updateDateForCurrArchive(data, data.isSingle);
                var archive = me._getArchiveById(data.archiveId);
                archive.status = data.status; 
                archive.dcStartParameter = data.status.status ? data.status.status.dcStartParameter : null;
            });

            $(document).on('loadingFinished', function (event, data) {
                if (!data || !data.done) return;

                me.myStatus.loading = false;
                me.myStatus.loadScreen.hide();

                // only show archive if user is currently in archive view
                if (me.myStatus.currentView === "archive") {
                    me.myStatus.overview.hide();
                    me.myStatus.archive.show();
                } else {
                    me.myStatus.archive.hide();
                }
            });

        } catch (e) { me._writeErr(e); }
    },

    _buildHtml: function () {
        /// <summary>
        /// builds up the main structure
        /// </summary>
        var me = this;
        try {
            me.myHtml = { menu: {} };

            // menu
            me.myHtml.menu = me._setObj("div-menu", "vc-grid-margin-right float vc-grid-margin-bottom");
            let obj = me.myHtml.menu;
            obj.width(me.myRoot.width());

            // overview button
            me.myStatus.btnOverview = me._setObj("btn-overview", "button-toggle").html("<i class='fa fa-medkit'>").attr("title", me.specific.resources.overview).css(ButtonTextStyle).css(OverViewBtnStyle).button();
            obj.append(me.myStatus.btnOverview);

            // overview content
            me.myStatus.overview = me._setObj("divOverviewContent", "");

            me.myStatus.archive = me._setObj("divArchiveContent", "");

            me.myStatus.loadScreen = me._setObj("divLoadingContent", "");

            me.myRoot.append(me.myHtml.menu);

        } catch (e) { me.writeError('_buildHtml', e); return false; }
        return true;
    },

    _initOverview: function () {
        /// <summary>
        /// initializes the datacenter overview
        /// </summary>
        var me = this;
        try {            
            let obj = me.myStatus.overview;
            obj.width(me.myRoot.width());
            obj.height(me.myRoot.height() - me.myHtml.menu.height());
            me.myRoot.append(obj);

            me.vcV.addVisualBaseByName("divOverview", 'VISUAL_DATACENTER_OVERVIEW', "Content", getCurrentTimestamp(), obj.height(), obj.width(), 'true', '', 1);

            me.myStatus.btnOverview.addClass("button-toggle-active");

        } catch (e) { me._writeErr(e); }
    },

    _initArchive: function (loggerId, loggerName) {
        /// <summary>
        /// initializes the archive and opens the archive with the desired loggerid and date
        /// </summary>
        var me = this;
        try {
            let obj = me.myStatus.archive;
            obj.width(me.myRoot.width());
            obj.height(me.myRoot.height() - me.myHtml.menu.height());
            obj.html(me.vcC.getLoadingIcon());
            me.myRoot.append(obj);

            console.log("############### me.myStatus.startParameter", me.myStatus.startParameter); 

            obj.show().RampArchive({
                invokeType: "addVisualContent", parameter: {
                    LoggerId: loggerId, Day: me.myStatus.currDate[0], DataCenterStart: true,
                    ShowInvalid: me.myStatus.startParameter.ShowInvalid, 
                    ShowInplausible: me.myStatus.startParameter.ShowInplausible,
                    ShowMissing: me.myStatus.startParameter.ShowMissing,
                    ShowRules: me.myStatus.startParameter.ShowRules
                }
            });

            me.myStatus.archives.push({
                status: {},
                archiveId: me.myStatus.uArchId,
                loggerId: loggerId,
                loggerName: loggerName,
                currDate: me.myStatus.currDate[0],
                interval: 1,
                isSingle: true
            });

            // initialize loading screen for the first time and hide it
            me.myStatus.loadScreen.html(me.vcC.getLoadingIcon());
            me.myRoot.append(me.myStatus.loadScreen);
            me.myStatus.loadScreen.hide();            

        } catch (e) { me._writeErr(e); }
    },

    _getDateResources: function () {
        /// <summary>
        /// gets the date resources to convert the selected date to the correct date string (depending on selected interval)
        /// </summary>
        var me = this;
        try {
            var dummy = $("<div>");
            dummy.vcDate({
                mode: "Single", align: "center", interval: 1, defaultDate: "", langID: 2, callback: function () {}
            });
            me.myStatus.resources = dummy.vcDate("getDateResources");
        } catch (e) { me._writeErr(e); }
    },

    _createAndInitializeArchive: function (obj, loggerName) {
        var me = this;
        try {
            me.myStatus.currentView = "archive";
            me._setCurrentDate(obj.day);
            me.myStatus.uArchId = 1;

            // init the archive
            me._initArchive(obj.loggerid, loggerName);
            me._createNewArchiveBtns(obj, loggerName);
            me.fnd("#btnLoad-1").click(); 

        } catch (e) { me._writeErr(e); }
    },

    _createNewArchiveBtns: function (obj, loggerName) {
        var me = this;
        try {
            // we create the archive load and close button and the click events for loading and closing the new archive
            me._createArchiveButton(obj.loggerid, obj.day, loggerName);
            me._createCloseButton(obj.loggerid, obj.day, loggerName);
            me._initArchiveButtonClick("#btnLoad-" + me.myStatus.uArchId, me.myStatus.uArchId, obj.loggerid, obj.day, loggerName);
            me._initCloseButtonClick("#btnClose-" + me.myStatus.uArchId, me.myStatus.uArchId, obj.loggerid, obj.day);

        } catch (e) { me._writeErr(e); }
    },


    _setDefaultStatus: function (obj, loggerName) {
        var me = this;
        try {

            me.defaultStatus.signals = null;

            me.defaultStatus.history = { list: [], current: -1, dirty: false };

            me.defaultStatus.ready = false;
            me.defaultStatus.firstDCFetchDone = false;
            me.defaultStatus.tempCharts = [];
            me.defaultStatus.currentTempChart = null;

            me.defaultStatus.settings = {
                blid: obj.loggerid,
                parameter: {
                    DataCenterStart: true,
                    Day: obj.day,
                    LoggerId: obj.loggerid,
                    ShowInvalid: obj.StartParameter.ShowInvalid,
                    ShowInplausible: obj.StartParameter.ShowInplausible,
                    ShowMissing: obj.StartParameter.ShowMissing,
                    ShowRules: obj.StartParameter.ShowRules
                }
            };

                // necessary, otherwise the mainChart is not loaded correctly!!
            me.defaultStatus.specific = {
                LoggerId: obj.loggerid,
                StartDate: obj.day,
                DataCenterStart: true,
                StartParameter: {
                    DataCenterStart: true,
                    ShowInvalid: obj.StartParameter.ShowInvalid,
                    ShowInplausible: obj.StartParameter.ShowInplausible,
                    ShowMissing: obj.StartParameter.ShowMissing,
                    ShowRules: obj.StartParameter.ShowRules
                }
            };

            me.defaultStatus.status = {
                date: {
                    singleDate: obj.day,
                    interval: 1,
                    dateComparisonType: -1,
                    isSingle: true
                },
                dcStartParameter: {
                    ShowInvalid: obj.StartParameter.ShowInvalid,
                    ShowInplausible: obj.StartParameter.ShowInplausible,
                    ShowMissing: obj.StartParameter.ShowMissing,
                    ShowRules: obj.StartParameter.ShowRules
                },
                dcFilters: { // ds filters integrated in the signal selection area
                    allProblematicSignals: null,
                    allSignalPlausibilities: null,
                    validityTypes: {  // holds all lists of filtered signals regarding the validity (invalid, unplausible, missing)                   
                        allInvalidSignals: [], // id 0
                        allUnplausibleSignals: [], // id 1
                        allMissingSignals: [] // id 2
                    },
                    signalTypes: { // holds all lists of filtered signals regarding signal type (rule, measure)
                        allOnlyMeasures: [], // id 0 -> index of buttons
                        allOnlyRules: [] // id 1                                      
                    },
                    additionalTypes: { // holds all lists of filtered signals regarding additional attributes (public, internal, etc)
                        allInactiveSignals: [], // id 0
                        allActiveSignals: [], // id 1
                        allSummables: [], // id 2
                        allNotSummables: [], // id 3
                        allPublics: [], // id 4
                        allInternals: [], // id 5
                        allDelayed: [], // id 6
                        allOnTime: [], // id 7
                        allImported: [], // id 8
                        allNotImported: [] // id 9                       
                    },
                    plausTypes: {
                        noPlaus: [], // id 0
                        allStandard: [], // id 1
                        allShutdowns: [], // id 2
                        allDisturbances: [], // id 3
                        allOutliers: [], // id 4
                        allConstantControls: [] // id 5
                    },        
                    autoCheckTypes: {
                        allACSignals: [], // id  0
                        allONSignals: [], // id 1
                        allOKSignals: [], // id 2
                        allNASignals: [], // id 3
                        allEditSignals: [] // id 4                        
                    },
                    filterLists: { // holds info regarding the currently selected filters (filter buttons active)
                        activeValFilters: [], // holds all currently selected validity filters (id of filter)
                        valFilteredSignals: [], // holds a list of all selected invalid signals
                        activeTypeFilters: [], // holds all currently selected type filters (id of filter)
                        typeFilteredSignals: [],  // holds a list of all selected type signals     
                        activeAddFilters: [], // holds all currently selected additional filters (id of filter)
                        addFilteredSignals: [], // holds a list of all additional type filters (e.g. public)
                        activePlausFilters: [],
                        plausFilteredSignals: [],
                        activeAutoCheckFilters: [],
                        autoCheckFilteredSignals: []
                    },
                    fileImportList: [78, 31, 58, 54, 74]

                },
                dirty: {
                    reload: false,
                    signals: false,
                    dtreeMenu: false,
                    plausList: false,
                    status: false,
                    details: false,
                    openTickets: null
                },
                menu: {
                    endDate: obj.day,
                    startDate: obj.day,
                    interval: 1,
                    chartType: "spline"
                },
                signals: {
                    allSelectedBsaids: [],
                    selectedBsaids: [],
                    allSelectedMeta: [],
                    selectedMeta: [],
                    hiddenSeries: [],
                    temperatureBsaid: -1,
                    shareParameter: null,
                    selectionLimit: 500
                },
                dataLoaded: false,
                firstChoiceFilled: false,
                madeSelection: false, 
                showContent: true,
                treeMenuId: 0
            };

        } catch (e) { me._writeErr(e); }

    },

    _setDesiredArchiveStatus: function (desiredStatus) {
        var me = this;
        try {
            me.defaultStatus = {};

            me.defaultStatus.data = desiredStatus.data; 
            me.defaultStatus.date = desiredStatus.date;
            me.defaultStatus.details = desiredStatus.details;
            me.defaultStatus.history = desiredStatus.history;
            me.defaultStatus.options = desiredStatus.options;

            me.defaultStatus.settings = desiredStatus.settings;

            me.defaultStatus.signals = desiredStatus.signals;            

            // necessary, otherwise the mainChart is not loaded correctly!!
            me.defaultStatus.specific = desiredStatus.specific;

            me.defaultStatus.status = desiredStatus.status;
            me.defaultStatus.tempCharts = desiredStatus.tempCharts;
            me.defaultStatus.currentTempChart = desiredStatus.currentTempChart;
            

        } catch (e) { me._writeErr(e); }

    },

    _openSelectedArchive: function (obj, loggerName) {
        /// <summary>
        /// opens the archive with the selected project and date
        /// </summary>
        var me = this;
        try {
            
            // first archive is opened
            if (me.fnd("#divArchiveContent").length === 0) {
                me.myStatus.loading = true;
                me._createAndInitializeArchive(obj, loggerName);                
            }
            else { // open new archive via overview
                me.myStatus.loading = true;

                me.myStatus.uArchId++; // new archive id

                me._setDefaultStatus(obj, loggerName);

                // get the currently selected date in the archive to update the currDate if date was changed in the archive                    
                var archWidget = me.myStatus.archive.find(".vc-menu");
                archWidget.trigger('openNewArchiveWithDefaultStatus', { param: archWidget.attr('id'), status: me.defaultStatus });

                me._setCurrentDate(obj.day);                

                me._createNewArchiveBtns(obj, loggerName);

                var foundButton = me.myStatus.menuButtons.find(function (button) {
                    return button.archiveId === me.myStatus.uArchId;
                });

                foundButton.div.find('div[id*="btnLoad-"]').click();

                me.myStatus.overview.hide();
                if (me.myStatus.loading) {
                    me.myStatus.archive.hide();
                    me.myStatus.loadScreen.show();
                }
                else {
                    me.myStatus.loadScreen.hide();
                    me.myStatus.archive.show();
                }

                // add new archive to archives array
                me.myStatus.archives.push({
                    archiveId: me.myStatus.uArchId,
                    loggerId: obj.loggerid,
                    loggerName: loggerName,
                    currDate: obj.day,
                    interval: 1,
                    isSingle: true,
                    dcStartParameter: me.myStatus.startParameter.StartParameter
                });
            }

        } catch (e) { me._writeErr(e); }
    },

    _createArchiveButton: function (loggerId, day, loggerName) {
        /// <summary>
        /// creates a new button for a new archive/project id in the top menu
        /// </summary>
        var me = this;
        try {
            var divArch = $("<div>").attr("id", "div-archive-" + me.myStatus.uArchId).css(ButtonFlexBox);
            var btnLoad = $("<div>").attr("id", "btnLoad-" + me.myStatus.uArchId)
                .data("archiveId", me.myStatus.uArchId)
                .data("loggerId", loggerId)
                .data("loggerName", loggerName)
                .data("date", day)
                .data("interval", 1)
                .addClass("button-toggle")
                .html(loggerName + "<br>" + day)
                .css(ButtonTextStyle)
                .button();
            divArch.append(btnLoad);
            me.myHtml.menu.append(divArch);

        } catch (e) { me._writeErr(e); }
    },

    _createCloseButton: function (loggerId, day, loggerName) {
        /// <summary>
        /// creates a new close button for a new archive/project id in the top menu
        /// </summary>
        var me = this;
        try {
            var btnClose = $("<div>").attr("id", "btnClose-" + me.myStatus.uArchId)
                .data("archiveId", me.myStatus.uArchId)
                .data("loggerId", loggerId)
                .data("loggerName", loggerName)
                .data("date", day)
                .data("interval", 1)
                .addClass("button-toggle")
                .html("<i class='fa fa-times icon-color-error'></i>")
                .css(ButtonTextStyle)
                .css("font-weight", "bold")
                .css("font-size", 14)
                .button();
            var divArch = me.fnd("#div-archive-" + me.myStatus.uArchId);
            divArch.append(btnClose);

            // add new menu button (entire div) for the new archive/project
            me.myStatus.menuButtons.push({
                div: divArch,
                archiveId: me.myStatus.uArchId,
                loggerId: loggerId,
                loggerName: loggerName,
                currDate: day,
                interval: 1
            });

            return divArch;
        } catch (e) { me._writeErr(e); }
    },

    _addClickEventHandler: function (selector, callback) {
        $(selector).off("click").on("click", callback);
    },

    _isArchiveExists: function (id) {
        var me = this;
        try {            
            return me.myStatus.archives.some(archive => archive.archiveId === id);
        } catch (e) { me._writeErr(e); }
    },

    _initArchiveButtonClick: function (archBtn, id, loggerId, day, loggerName) {
        /// <summary>
        /// inits the archive button click event for loading the desired archive/project
        /// </summary>
        var me = this;
        try {
            me._addClickEventHandler(archBtn, function () {
                me._toggleActiveClass(id);

                var currArchive = me._getArchiveById(me.myStatus.currArchiveId);
                // check if an archive is currently opened; then status must be saved, before switching to other archive
                if (currArchive && !me.myStatus.overview.is(":visible")) {  
                    me.myStatus.loading = true;

                    // get the currently selected date in the archive to update the currDate if date was changed in the archive
                    var archWidget = me.myStatus.archive.find(".vc-menu");
                    archWidget.trigger('getStatusOfCurrArchive', { widgetId: archWidget.attr('id'), archiveId: me.myStatus.currArchiveId });

                    // to be on the safe side, we use setTimeout, so that archive status is saved for sure before swithcing the archive
                    setTimeout(function () {
                        me.myStatus.currentView = "archive";
                        me.myStatus.overview.hide();
                        me.myStatus.btnOverview.removeClass("button-toggle-active");  

                        me._loadDesiredArchive(id);
                        me.myStatus.currArchiveId = id;
                        me._setCurrentDate(day);
                    }, 0);

                }
                else {
                    me.myStatus.currentView = "archive";
                    me.myStatus.overview.hide();
                    me.myStatus.btnOverview.removeClass("button-toggle-active");  

                    me._loadDesiredArchive(id);
                    me.myStatus.currArchiveId = id;
                    me._setCurrentDate(day);
                }                            

            });
        } catch (e) { me._writeErr(e); }
    },

    _loadDesiredArchive: function (id) {
        var me = this;
        try {
            if (me.myStatus.currArchiveId === id) {
                me.myStatus.archive.show();
            }
            else if (me.myStatus.currArchiveId > 0 && me._isArchiveExists(id)) { // load existing archive

                // get the currently selected date in the archive to update the currDate if date was changed in the archive                  
                var currArchive = me._getArchiveById(id);

                var archWidget = me.myStatus.archive.find(".vc-menu");
                me._setDesiredArchiveStatus(currArchive.status);
                archWidget.trigger('loadStatusOfArchive', { param: archWidget.attr('id'), status: me.defaultStatus });

                if (me.myStatus.loading) {
                    me.myStatus.archive.hide();
                    me.myStatus.loadScreen.show();
                }
                else {
                    me.myStatus.loadScreen.hide();
                    me.myStatus.archive.show();
                }
            }

        } catch (e) { me._writeErr(e); }
    },

    _initCloseButtonClick: function (closeBtn, id, loggerId, day) {
        /// <summary>
        /// inits the close button click event for closing a desired archive/project
        /// </summary>
        var me = this;
        try {
            me._addClickEventHandler(closeBtn, function () {
                var archive = me._getArchiveById(id);
                if (archive) {
                    // remove eventListeners of close and load button
                    $(closeBtn).off('click');
                    $("btnLoad-" + id).off('click');
                    me.myStatus.archives = me.myStatus.archives.filter(function (existingArchive) {
                        return !(existingArchive.archiveId === id);
                    }); 

                    me.myStatus.menuButtons = me.myStatus.menuButtons.filter(function (button) {
                        return !(button.archiveId === id); 
                    });

                    if (me.myStatus.currArchiveId === id) {
                        me.myStatus.btnOverview.click();
                    }

                }

                // remove div of archive buttons
                var divArch = me.fnd("#div-archive-" + id); 
                $(divArch).removeData();
                $(divArch).remove();
                divArch = null;

            });
        } catch (e) { me._writeErr(e); }
    },



    _getArchiveById: function (id) {
        /// <summary>
        /// filters all open archives and returns the archive with the given archive id
        /// </summary>
        var me = this;
        try 
        {
            var currentArchive = me.myStatus.archives.find(function (archive) {
                return archive.archiveId === id;
            });

            if (currentArchive) return currentArchive;
            else return null;    
            
         } catch (e) { me._writeErr(e); }
    }, 


    _setCurrentDate: function (day) {
        /// <summary>
        /// set the current date to the new selected date
        /// </summary>
        var me = this;
        try {
            if (day != "") {
                me.myStatus.currDate[0] = day;
            }
            else
                me.myStatus.currDate = [];

        } catch (e) { me._writeErr(e); }
    },

    _showOverview: function () {
        /// <summary>
        /// switches to and shows the datacenter overview
        /// </summary>
        var me = this;
        try {
            me.myStatus.overview.show();
            me.myStatus.btnOverview.addClass("button-toggle-active");
        } catch (e) { me._writeErr(e); }
    },

    _updateDateForCurrArchive: function (newDate, isSingle) {
        /// <summary>
        /// updates the whole saved date info for the currently open archive (before switching to overview or other archive)
        /// </summary>
        var me = this;
        try {
            var currArchive = me._getArchiveById(me.myStatus.currArchiveId);
            var finalDate;

            if (!isSingle)
                finalDate = newDate.date.from;
            else
                finalDate = newDate.date;

            if (currArchive) {
                currArchive.currDate = finalDate;
                currArchive.interval = newDate.interval;
                currArchive.isSingle = isSingle;
            }

            var foundButtons = me.myStatus.menuButtons.find(function (button) {
                return button.archiveId === me.myStatus.currArchiveId;
            });

            if (foundButtons) {
                foundButtons.currDate = finalDate;
                foundButtons.interval = newDate.interval;

                foundButtons.div.find('div[id*="btnLoad-"], div[id*="btnClose"]').each(function () {
                    $(this).data("date", finalDate);
                    $(this).data("interval", newDate.interval);
                });                
            }

            // update button label
            me._updateButtonLabel(newDate, isSingle);

        } catch (e) { me._writeErr(e); }
    },

    _updateButtonLabel: function (newDate, isSingle) {
        /// <summary>
        /// updates the load button label with the latest selected date in the corresponding archive
        /// </summary>
        var me = this;
        try {
            var buttonLabel = me.fnd("#btnLoad-" + me.myStatus.currArchiveId).find('.ui-button-text'); // get the span
            var currentText = buttonLabel.html();
            var updatedText = "";

            if (!isSingle) { // dateRange is selected
                var start = me._getDateString(newDate.date.from, 1);
                var end = me._getDateString(newDate.date.to, 1);
                updatedText = currentText.replace(/(<br>).*$/, '$1' + start + "-" + end);
                buttonLabel.html(updatedText);
            }
            else { // singleDate is selected
                var date = me._getDateString(newDate.date, newDate.interval);
                updatedText = currentText.replace(/(<br>).*$/, '$1' + date);
            }

            buttonLabel.html(updatedText);

        } catch (e) { me._writeErr(e); }
    },

    _getDateString: function (currDate, interval) {
        /// <summary>
        /// gets the current date as string for the button label
        /// </summary>
        var me = this;
        try {
            var date;
            switch (interval) {
                case 1:
                    date = currDate;
                    break;
                case 3:
                    date = me.myStatus.resources.months[moment(currDate, "DD.MM.YYYY").toDate().format("MM") - 1] + " " + moment(currDate, "DD.MM.YYYY").toDate().format("yyyy");
                    break;
                case 5:
                    date = moment(currDate, "DD.MM.YYYY").toDate().format("yyyy");
                    break;
                default:
                    break;
            }

            return date;

        } catch (e) { me._writeErr(e); }
    },

    _toggleActiveClass: function (id) {
        /// <summary>
        /// sets the currently selected project button to active
        /// </summary>
        var me = this;
        try {
            me.fnd('div[id^="btnLoad-"]').removeClass('button-toggle-active');
            me.fnd('#btnLoad-' + id).addClass('button-toggle-active');
        } catch (e) { me._writeErr(e); }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {  }
            return true;
        } catch (e) { me.writeError('specificInfoHandling', e); return false; }
    }


});

